import { useContext, useState } from 'react';
import { ReactComponent as GenerateIcon } from '@elementary/common-ui/assets/ai-generate-magenta.svg';
import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/info-icon.svg';
import { ReactComponent as VIcon } from '@elementary/common-ui/assets/v-green.svg';
import {
  Flex,
  FlexCenter,
  InternalLink,
  PageAlert,
} from '@elementary/common-ui/components';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import { TrackingContext } from '@elementary/common-ui/providers/tracking';
import { Typography } from '@mui/material';

type Props = {
  variant?: 'alert' | 'infoLabel';
  width?: string;
};

const AiAccessAlert = ({ variant = 'alert', width }: Props) => {
  const [isAiAlertVisible, setIsAiAlertVisible] = useState(true);
  const [isRequestedAiAccess, setIsRequestedAiAccess] = useState(false);
  const { data: account } = useAccount();
  const tracking = useContext(TrackingContext);
  const trackingEvents = tracking?.analytics.events;

  const handleRequestAiAccess = () => {
    tracking?.sendTrackingEvent({
      eventName: trackingEvents?.REQUEST_AI_ACCESS,
    });
    setIsRequestedAiAccess(true);
  };

  if (!isAiAlertVisible || account?.ai_features_enabled) {
    return null;
  }

  const alertContent = isRequestedAiAccess ? (
    <>
      Get access to AI features and agents.{' '}
      <b>Access requested successfully.</b>
    </>
  ) : (
    <>
      Get access to AI features and agents. Click{' '}
      <InternalLink to="." onClick={handleRequestAiAccess}>
        here
      </InternalLink>{' '}
      to ask the Elementary team.
    </>
  );

  if (variant === 'alert') {
    return (
      <PageAlert
        severity={isRequestedAiAccess ? 'success' : 'info'}
        icon={<GenerateIcon />}
        onClose={() => setIsAiAlertVisible(false)}
      >
        {alertContent}
      </PageAlert>
    );
  }

  return (
    <Flex sx={{ gap: 0.5, width }}>
      <FlexCenter
        sx={{
          height: '16px',
          width: '16px',
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        {isRequestedAiAccess ? <VIcon height={11} /> : <InfoIcon />}
      </FlexCenter>
      <Typography sx={{ fontSize: '11px', color: 'common.gray2' }}>
        {alertContent}
      </Typography>
    </Flex>
  );
};

export default AiAccessAlert;
